<template>
  <div>
    <section v-if="!!cartorioObj.mensalista"
             class="content--sinoreg ">
      <header class="headerBlue">
        <h4 class="resumo-show_title pl-2 mt-3">
          <span class="pt-3 resumo-show_title-label">
            Mensalistas
          </span>
        </h4>
      </header>
      <div class="d-flex justify-content-between align-items-lg-center pt-4">
        <BuscarMensalistas class="col-6" />
        <AddMensalista class="col-6" />
      </div>
      <TabelaMensalistas />
    </section>
    <section v-else>
      {{ handlerCaixaDesativado() }}
    </section>
  </div>
</template>

<script>
  // Componentes
  import BuscarMensalistas from './BuscarMensalistas/BuscarMensalistas.vue'
  import AddMensalista from './AddMensalista/AddMensalista.vue'
  import TabelaMensalistas from './TabelaMensalistas/TabelaMensalistas.vue'

  // Services
  import MensalistaService from './mensalistaService'


  export default ({
    name: 'Mensalistas',
    components: {
      BuscarMensalistas,
      AddMensalista,
      TabelaMensalistas
    },
    data () {
      return {
        cartorioObj: null
      }
    },
    computed: {
      handlerCaixaDesativado () {
        return displayMessage('error', 'Mensalistas desativado', 'Para ativar e começar a usar o modulo Mensalistasacesse no menu lateral => Cadastro serventia e clique no módulo para ativa-lo.') 
      }
    },
    async created () {
      this.init()
      this.cartorioObj = this.$store.state.auth.cartorioObj
    },
    methods: {
      async init () {
        try {
          // Pega os mensalistas para listar e distribuir
          loader ({text: 'Buscando Mensalistas', active: true})
          const mensalistas = await MensalistaService.getMensalistas()
          this.$store.dispatch('frenteCaixa/atualizarMensalistas', mensalistas)
        } catch (err) {
          console.log('Mensalista', err)
        } finally {
          loader ({text: null, active: false})
        }
      },
    }
  })
</script>

<style lang="scss" scoped>
  @import "../../../../scss/_utilities/_variables";
  .headerBlue{
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    font-size: pxToRem(20);
    font-weight: 500;
    height: 100%;
    width: 100%;
  }
</style>
